import { render, staticRenderFns } from "./Enrichment.vue?vue&type=template&id=05ebe697&"
import script from "./Enrichment.vue?vue&type=script&lang=js&"
export * from "./Enrichment.vue?vue&type=script&lang=js&"
import style0 from "./Enrichment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports